
/**
 * @returns {Function} Обрезание строки
 *
 * @param {Number} str - строка
 */
export default (str) => {
    let res = str;
    if (str.length > 15) {
        res = res.slice(0, -(str.length - 15)) + "...";
    }
    return res;
};
